// extracted by mini-css-extract-plugin
export default {"container":"id3a4H5VmqnY0_zuO6mv"};